import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/index'

export const TimerSC = styled.div`
  display: flex;
`

export const TimeBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: var(${FIXED_INDENTS.INDENT_10});
  flex: 1;
`

export const TimerWrapper = styled.div<{
  rowGap: FIXED_INDENTS
  columnGap: FIXED_INDENTS
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: ${({ rowGap }) => `var(${rowGap})`};

  ${TimerSC} {
    column-gap: ${({ columnGap }) => `var(${columnGap})`};
  }
`
